<template>
  <div>
    <stock-detail
      detailType="stockDetail"
      ref="stockDetail"
      :tableData="tableData"
      :baseInfo="baseInfo"
      @tabChange="onTabChange"
    ></stock-detail>
  </div>
</template>

<script>
import StockDetail from "@/components/stock-detail/index.vue";
import { chartData } from "@/libs/test.js";
export default {
  components: {
    "stock-detail": StockDetail,
  },
  data() {
    return {
      tableData: {},
      baseInfo: {},
    };
  },
  mounted() {
    this.loading = this.$loading();
    this.getChartDetail("YTD");
  },
  methods: {
    getChartDetail(dataLength, reset = false) {
      let type = this.$route.query.type;

      return this.$tool
        .fetchPost("/api/getCharts2Detail", {
          type,
          dataLength,
        })
        .then((res) => {
          this.loading.close();
          if (res.code == 200) {
            let { table, name, desc, dataList } = res.data;
            this.tableData = table;
            this.baseInfo = { name, desc };
            let XTime = dataList.map((item) => item.DATE);
            let YData = dataList.map((item) => {
              if(item.Close === '' || !item.Close){
                item.Close = '-';
              }
              if(item.Open === '' || !item.Open){
                item.Open = '-';
              }
              if(item.High === '' || !item.High){
                item.High = '-';
              }
              if(item.Low === '' || !item.Low){
                item.Low = '-';
              }
              return {
                ...item,
                value: (item.Close=='' || !item.Close)?'0':item.Close,
              };
            });
            if (!reset) {
              this.$refs.stockDetail.setData(XTime, YData);
            } else {
              this.$refs.stockDetail.setOption(XTime, YData);
            }
            this.$refs.stockDetail.hideLoading();
          }
        })
        .catch(() => {
          this.loading.close();
        });
    },
    onTabChange(item) {
      console.log(item);
      this.$refs.stockDetail.loadingFn();
      this.getChartDetail(item, true);
    },
  },
};
</script>

<style lang="scss" scoped></style>
